/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { Observable } from 'rxjs';

import { ENV_VARIABLES, EnvVariables } from '@evc/web-components';

import { AuthInterceptorExclusionService } from './exclusion.service';

export const SKIP_AUTH_HEADER = 'X-Skip-Auth';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor extends MsalInterceptor {
  #authExclusionService = inject(AuthInterceptorExclusionService);
  #env = inject(ENV_VARIABLES) as unknown as EnvVariables;

  /**
   * Will skip MsalInterceptor if either
   * - request have 'X-Skip-Auth' header
   * - request URL matches any unprotected url | patterns
   */
  override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.shouldSkipAuth(req) ? next.handle(req) : super.intercept(req, next);
  }

  private shouldSkipAuth(req: HttpRequest<any>): boolean {
    if (req.headers.has(SKIP_AUTH_HEADER)) return true;

    return this.#authExclusionService.shouldSkipAuth(req.url);
  }
}
